/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconEvent/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconEvent({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconEvent",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconEvent.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-m8WtG': alignSelf,'--mt-2-m8WtG': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-m8WtG': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-m8WtG': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-m8WtG': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-m8WtG': opacity,'--w-10-m8WtG': typeof width === 'number' ? `${width}px` : width,'--h-11-m8WtG': typeof height === 'number' ? `${height}px` : height,'--a-7-m8WtG': isAnimated ? animation : "none",'--sd-8-m8WtG': isAnimated ? strokeDashoffset : 0,'--sd-9-m8WtG': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconEvent.SvgPath"
  data-view-path={viewPath}
 d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zm-7 5h5v5h-5z"
 style={{'--f-12-m8WtG': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}